export default {
      id: "units__parking_symbol-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#units__parking_symbol",
      toString: function () {
        return this.url;
      }
    }